// extracted by mini-css-extract-plugin
export default {"container":"PrescriptionRenewalsTab_container__StzpC"};